import { useQueryClient } from "@tanstack/react-query"
import { useEffect } from "react";
import { getInitData } from "services/apiAuth1";

const AppInitializer = ({children}) => {
  const queryClient = useQueryClient();

  useEffect(()=>{
    const initialize = async ()=>{
        try{
            await Promise.all([
                queryClient.prefetchQuery({
                    queryKey: ['initialData'],
                    queryFn: getInitData,
                    staleTime: 60 * 60 * 1000,
                    gcTime: 24 * 60 * 60 * 1000
                })
            ])
        }catch(error){
            console.log("Initialize data",error)
        }
    }

    initialize();
  },[queryClient])

  return children;
}

export default AppInitializer
